// extracted by mini-css-extract-plugin
export default {"learn":"Learn_learn__q0Q6S","title":"Learn_title__GHn-n","questionOrAnswer":"Learn_questionOrAnswer__njBM2","counter":"Learn_counter__Rm4cd"};